import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialDialog } from '../dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from '../base.component';
import { Payment } from 'app/core/interfaces/payment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from 'app/core/http/services/payment.service';

@Component({
  selector: 'src-confirmation-payment-code',
  templateUrl: './confirmation-payment-code.component.html',
  styleUrls: ['./confirmation-payment-code.component.css'],
})
export class ConfirmationPaymentCodeComponent extends BaseComponent implements OnInit {
  paymentCodeForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private fb: FormBuilder,
    private paymentService: PaymentService,
  ) {
    super(injector);
  }

  public payment!: Payment;
  public submitted: Boolean = false;

  ngOnInit(): void {
    this.payment = this.data.param.payment;

    this.paymentCodeForm = this.fb.group({
      code: ['', [Validators.required, Validators.pattern('[A-Za-z0-9]{6}')]],
    });

    console.log('payment', this.payment);
  }

  codeIsMatch() {
    if (this.paymentCodeForm.invalid) return;

    this.submitted = true;
    this.paymentService.verifyAttendanceCode(this.payment.payment_id!, this.paymentCodeForm.value.code).subscribe({
      next: () => this.dialogRef.close(true),
      error: () => undefined,
    });
  }
}
